<template>
  <div class="credentials-dialog">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">API credentials</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="clientId"
            outlined
            hide-details
            readonly
            label="Client ID"
            class="pa-2 mt-2"
            append-icon="mdi-content-copy"
            @click:append="copyToClipBoard(clientId)"
          ></v-text-field>
          <v-text-field
            v-model="clientSecret"
            outlined
            hide-details
            readonly
            label="Client Secret"
            class="pa-2"
            append-icon="mdi-content-copy"
            @click:append="copyToClipBoard(clientSecret)"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('close')">Close</v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar :timeout="1000" v-model="snackbar" color="success">Copied !</v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, required: true },
    clientId: { type: String, required: true },
    clientSecret: { type: String, required: true }
  },
  data(){
    return {
      snackbar: false
    }
  },
  methods: {
    copyToClipBoard(value) {
      navigator.clipboard.writeText(value);
      this.snackbar=true
    }
  }
};
</script>

<style>
</style>